import React, { useState, useEffect } from "react";
import clsx from "clsx";
import SportsTeamLogo from "components/teamLogo";
import style from "./style.module.scss";
import { observer } from "mobx-react";
import BasketballTracker from "./tracker";
import BasketballViewRegular from "./regular";
import BasketballViewRecord from "./record";
import Banner from "../../../../components/banner";
import useStore from "../../../../hooks/useStore";
import { _SPORTS_TYPE } from "../../../../common/constants/sportsConstants";
import { getStreamBrowser } from "../../liveStream/util";

const BasketballView = observer(
  ({ item, isSelected, setSelectedGame, isPopup, isAdmin, openCaster }) => {
    const { quarterArr, oddsData, period, teamFoul, summaryScore } = item;
    const [isOverView, setOverView] = useState(false);
    const [overPeriod, setOverPeriod] = useState(0);
    const { bannerStore } = useStore();

    useEffect(() => {
      if (
        !bannerStore.activeMajorViewId ||
        bannerStore.activeMajorViewId === "placeholder"
      ) {
        if (Number.isInteger(item.id)) {
          bannerStore.setActiveMajorView(item.id, _SPORTS_TYPE.BASKETBALL);
        }
      }
    }, [bannerStore, bannerStore.activeMajorViewId, item.id]);

    useEffect(() => {
      setOverPeriod(period > 4 ? 1 : 0);
      setOverView(period > 4);
    }, [period]);

    const onClickDetail = () => {
      window.open(
        `/match/basketball/${item.id}`,
        `detail_${item.id}`,
        "width=1000px,height=901px,scrollbars=yes"
      );
    };

    // const onClickVideo = () => {
    //   window.open(
    //     item.videoLink,
    //     `live_${item.id}`,
    //     "width=980px,height=750px,scrollbars=yes"
    //   );
    // };
    const onClickVideo = () => {
      getStreamBrowser(item.videoLink);
    };

    const onClickBetble = () => {
      let type = 0;

      if (item.getTracker.status === "progress") {
        type = 1;
      }

      const url = `https://betble.com/game/game.php?type=${type}${item.betbleUri}`;

      window.open(url);
    };

    const onClickPrev = () => {
      setOverPeriod(0);
    };

    const onClickNext = () => {
      setOverPeriod(1);
    };

    const setSelectedItem = () => {
      setSelectedGame(
        isSelected,
        item.id,
        item.startDatetime,
        item.gameStatus,
        "basketball"
      );
    };

    return (
      <>
        <div className={style.score_board}>
          {/* tracker  */}
          <BasketballTracker item={item} isPopup={isPopup} />
          {/*// tracker  */}

          {/* summary_score  */}
          <div className={style.summary_score}>
            <div className={style.info}>
              <span className={style.league}>{item.league.shortName}</span>
              <span className={style.time}>{item.getStartDateTime}</span>
              {item.getTracker.status === "progress" && (
                <span className={style.displayTime}>{item.displayTime}</span>
              )}
              <span
                className={clsx(
                  style.state,
                  item.getTracker.status === "progress" && style.on
                )}
              >
                {item.statusText}
              </span>
            </div>
            <div className={style.team_area}>
              <div className={clsx(style.team, style.away)}>
                <SportsTeamLogo
                  imgSize={"55"}
                  imgUrl={!!item.teams ? item.teams.away.imgPath : null}
                  isLazy={true}
                />
                <div className={style.name}>
                  <span>{item.getTeamData.away.name}</span>
                </div>
                <div
                  className={clsx(
                    style.point,
                    item.getTeamData.home.score < item.getTeamData.away.score &&
                      style.on
                  )}
                >
                  {item.getTeamData.away.score}
                </div>
                {item.getTracker.status === "progress" && (
                  <div
                    className={clsx(
                      style.team_foul,
                      !!teamFoul.away && style[`f${teamFoul.away}`]
                    )}
                  ></div>
                )}
              </div>
              <div className={clsx(style.team, style.home)}>
                <SportsTeamLogo
                  imgSize={"55"}
                  imgUrl={!!item.teams ? item.teams.home.imgPath : null}
                  isLazy={true}
                />
                <div className={style.name}>
                  <span>{item.getTeamData.home.name}</span>
                </div>
                <div
                  className={clsx(
                    style.point,
                    item.getTeamData.home.score > item.getTeamData.away.score &&
                      style.on
                  )}
                >
                  {item.getTeamData.home.score}
                </div>
                {item.getTracker.status === "progress" && (
                  <div
                    className={clsx(
                      style.team_foul,
                      !!teamFoul.home && style[`f${teamFoul.home}`]
                    )}
                  ></div>
                )}
              </div>
            </div>
            <div className={style.btn_area}>
              {!isPopup && (
                <>
                  <button
                    className={clsx(
                      style.btn,
                      style.btn_arrow,
                      isSelected ? style.down : style.up
                    )}
                    onClick={setSelectedItem}
                  >
                    올리기/내리기
                  </button>
                  <button
                    className={clsx(style.btn, style.btn_cast)}
                    onClick={onClickDetail}
                  >
                    상세보기
                  </button>
                  {/*{item.betbleButtonVisible && (*/}
                  {/*  <button*/}
                  {/*    className={clsx(style.btn, style.betting)}*/}
                  {/*    onClick={onClickBetble}*/}
                  {/*  >*/}
                  {/*    베팅*/}
                  {/*  </button>*/}
                  {/*)}*/}
                  {!!item.videoLink && ( item.gameStatus === "IN_PROGRESS" || item.gameStatus === "BREAK_TIME" || item.gameStatus === "PAUSE" ) && (
                    <button
                      className={clsx(style.btn, style.btn_live)}
                      onClick={onClickVideo}
                    >
                      생중계
                    </button>
                  )}
                  {isAdmin && (
                    <button
                      className={clsx(style.btn, style.btn_admin)}
                      onClick={() => openCaster(3, item.id)}
                    >
                      AD
                    </button>
                  )}
                </>
              )}
            </div>
            <span className={style.total_score}>합계 : {summaryScore}</span>
          </div>
          {/*// summary_score  */}

          {/* detail_score  */}
          <div className={style.detail_score}>
            <div
              className={clsx(
                style.board,
                isOverView && style.overtime,
                style[item.getTracker.class]
              )}
            >
              {item.getTracker.status === "ready" ? (
                <BasketballViewRecord item={item} />
              ) : (
                <div className={style.regular}>
                  <div className={style.inner}>
                    <div
                      className={style.box}
                      style={{ left: -(overPeriod * 80 + 1) }}
                    >
                      {quarterArr.map((quarter) => {
                        return (
                          <BasketballViewRegular
                            quarter={quarter}
                            item={item}
                            key={`basketball-regular-${quarter.key}`}
                          />
                        );
                      })}
                    </div>
                  </div>
                  {isOverView && (
                    <div className={style.btn_more}>
                      <button
                        className={clsx(style.btn, style.btn_prev)}
                        onClick={onClickPrev}
                      >
                        더보기
                      </button>
                      <button
                        className={clsx(style.btn, style.btn_next)}
                        onClick={onClickNext}
                      >
                        더보기
                      </button>
                    </div>
                  )}
                </div>
              )}
              <dl className={clsx(style.item, style.odds)}>
                <dt>국내</dt>
                <dd>
                  <span>
                    {!!oddsData.domestic.away && oddsData.domestic.away}
                  </span>
                  <span>
                    {!!oddsData.domestic.awayOption &&
                      oddsData.domestic.awayOption}
                  </span>
                </dd>
                <dd>
                  <span>
                    {!!oddsData.domestic.home && oddsData.domestic.home}
                  </span>
                  <span>
                    {!!oddsData.domestic.homeOption &&
                      oddsData.domestic.homeOption}
                  </span>
                </dd>
              </dl>
              <dl
                className={clsx(style.item, style.odds)}
                style={{ borderRight: "none" }}
              >
                <dt>해외</dt>
                <dd>
                  <span>
                    {!!oddsData.international.away &&
                      oddsData.international.away}
                  </span>
                  <span>
                    {!!oddsData.international.awayOption &&
                      oddsData.international.awayOption}
                  </span>
                </dd>
                <dd>
                  <span>
                    {!!oddsData.international.home &&
                      oddsData.international.home}
                  </span>
                  <span>
                    {!!oddsData.international.homeOption &&
                      oddsData.international.homeOption}
                  </span>
                </dd>
              </dl>
            </div>
          </div>
          {/*// detail_score  */}
        </div>
        {bannerStore.activeMajorViewId === item.id ? (
          <Banner paddingTop="10px" paddingBottom="0" />
        ) : null}
      </>
    );
  }
);

export default BasketballView;
